import { z } from 'zod';
/**
 * How a new Job purchase order starts (Jacky, 5 October 2026, on Ameer J-0826-10211): required-by is
 * prefilled `lead_working_days` working days before the installation, and the destination is chosen
 * from pickup (the default), the Artemis warehouse, or a typed address.
 *
 * `non_working_days` holds the weekday public holidays the count skips (weekends are always skipped).
 * Seeded with NSW weekday public holidays for 2026–2027; Anzac Day falls on a weekend both years and
 * NSW adds no substitute day. Add a year here when it is published — nothing in code needs to change.
 */
const DAY = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'YYYY-MM-DD');
export const PurchaseOrderDefaultsSchema = z.object({
    lead_working_days: z.number().int().min(0).max(30),
    pickup_text: z.string().trim().min(3).max(120),
    warehouse: z.object({ label: z.string().trim().min(2).max(80), address: z.string().trim().min(5).max(250) }),
    non_working_days: z.array(DAY).max(200),
    /** Jacky, 9 Oct 2026 (to EmmA, WeChat): recent board orders were cut too fine, so every PO ordered this
     *  much more FLOOR (the quote's main floor lines, by the m²), rounded up to whole boxes; unused full
     *  boxes go back to the supplier. SUPERSEDED 15 Oct 2026 by the fixed spare below ("build on area +
     *  wastage + extra 2 SQM") — the quoted quantity already carries the Proposal's wastage, so a percentage
     *  on top of it was wastage twice. Kept as a knob (0 = off); set it here if a percentage is ever wanted again. */
    floor_overage_pct: z.number().min(0).max(25).default(0),
    /** Jacky, 15 Oct 2026 (Ameer J-0826-10211, more planks needed after the drawing was re-read): a floor is
     *  ordered on AREA + WASTAGE (the Proposal's quantity) + this many spare m², then rounded up to whole boxes.
     *  Underlay, trims and the other accessories take none. */
    floor_extra_m2: z.number().min(0).max(50).default(2),
});
export const purchaseOrderDefaults = {
    lead_working_days: 2,
    floor_overage_pct: 0,
    floor_extra_m2: 2,
    pickup_text: 'Pickup — Artemis Flooring will collect',
    warehouse: { label: 'Artemis Warehouse', address: 'Unit 15 / 20–22 St Albans Rd, Kingsgrove NSW 2208' },
    non_working_days: [
        '2026-01-01', '2026-01-26', '2026-04-03', '2026-04-06', '2026-06-08', '2026-10-05', '2026-12-25', '2026-12-28',
        '2027-01-01', '2027-01-26', '2027-03-26', '2027-03-29', '2027-06-14', '2027-10-04', '2027-12-27', '2027-12-28',
    ],
};
//# sourceMappingURL=purchase-order-defaults.js.map